'use client';
import { createBareContext } from '@s7/react-utils';

var _createBareContext = createBareContext();
var FooterAnalyticsProvider = _createBareContext[0], useAnalyticsContext = _createBareContext[1];
var useFooterAnalytics = function() {
    var _useAnalyticsContext;
    return (_useAnalyticsContext = useAnalyticsContext()) == null ? void 0 : _useAnalyticsContext.topic;
};

export { FooterAnalyticsProvider, useAnalyticsContext, useFooterAnalytics };
